const app = require('app');
const Marionette = require('backbone.marionette'),
    M = require('shared/messages/messages'),
    handleServerError = require('shared/helpers/handleServerError');

module.exports = Marionette.Behavior.extend({
    // returnUrl:
    // - false: Remain on current page.
    // - function: Navigate to returned value, or reload current page if value is identical to current route.
    initialize: function(
        {
            modelProperty = 'model',
            noun = 'model',
            savePromiseGenerator = (view, model) => model.save(),
            deletePromiseGenerator = (view, model) => model.destroy(),
            returnUrl = false
        }) {
        const view = this.view;
        view.saveChange = this.saveChange.bind(view);
        view.onSaveSuccess = this.onSaveSuccess.bind(view);
        view.onSave = (e) => {
            return view.saveChange.apply(view, [modelProperty, e, noun, savePromiseGenerator, returnUrl, null, true]);
        };
        view.onDelete = (e) => {
            return view.saveChange.apply(view, [modelProperty, e, noun, deletePromiseGenerator, returnUrl, null, false]);
        };
    },
    saveChange: function(modelProperty, e, noun, promiseGenerator, returnUrl, callBack, needValidation) {
        if (needValidation !== false && this[modelProperty] && this[modelProperty].isValid && !this[modelProperty].isValid(true)) {
            return;
        }
        let promise = promiseGenerator(this, this[modelProperty]);
        if (this.waitOn && e) {
            this.waitOn(promise, e);
        }
        if (this.lockFormOn) {
            this.lockFormOn(promise);
        }
        promise.done(function () {
            app.notifySuccess(M.saved());
            this.onSaveSuccess(returnUrl, modelProperty);
            if (_.isFunction(callBack)) {
                callBack.apply(this, arguments);
            }
        }.bind(this));
        promise.fail(resp => handleServerError(this, resp));

        return promise;
    },
    onSaveSuccess: function(returnUrl, modelProperty) {
        if (_.isFunction(returnUrl)) {
            returnUrl = returnUrl.call(this, this[modelProperty]);
        }
        if (returnUrl === false) {
            return;
        }
        if (returnUrl) {
            app.navigateRoute({ route: returnUrl });
        }
        else {
            app.navigateBack();
        }
    }
});
